import { render, staticRenderFns } from "./Novias.vue?vue&type=template&id=110eeb51&"
import script from "./Novias.vue?vue&type=script&lang=js&"
export * from "./Novias.vue?vue&type=script&lang=js&"
import style0 from "./Novias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports